import { ValueOfKey } from '../../../utils-types';

export const NAVIGATION_ICON = {
  /** MUI icons */
  ACCESSIBILITY_NEW: 'ACCESSIBILITY_NEW',
  ACCOUNT_BALANCE_WALLET: 'ACCOUNT_BALANCE_WALLET',
  ASSIGNMENT: 'ASSIGNMENT',
  ASSIGNMENT_IND: 'ASSIGNMENT_IND',
  AS_PDF: 'AS_PDF',
  ATTACH_MONEY: 'ATTACH_MONEY',
  AUTO_STORIES: 'AUTO_STORIES',
  BACKUP_TABLE: 'BACKUP_TABLE',
  BAR_CHART: 'BAR_CHART',
  BUSINESS: 'BUSINESS',
  BUSINESS_CENTER: 'BUSINESS_CENTER',
  CHAT: 'CHAT',
  DATE_RANGE: 'DATE_RANGE',
  DESCRIPTION: 'DESCRIPTION',
  EMOJI_EVENTS: 'EMOJI_EVENTS',
  FOLDER_OPEN: 'FOLDER_OPEN',
  HOME: 'HOME',
  IMPORT_CONTACTS: 'IMPORT_CONTACTS',
  INSERT_CHART: 'INSERT_CHART',
  LEADERBOARD: 'LEADERBOARD',
  LIST_ALT: 'LIST_ALT',
  MANAGE_ACCOUNTS: 'MANAGE_ACCOUNTS',
  NEW_RELEASES: 'NEW_RELEASES',
  PEOPLE_OUTLINE: 'PEOPLE_OUTLINE',
  PERCENT: 'PERCENT',
  PLAY_ARROW: 'PLAY_ARROW',
  ROCKET: 'ROCKET',
  SCHOOL: 'SCHOOL',
  SETTINGS: 'SETTINGS',
  SPA: 'SPA',
  SPORTS_BASEBALL: 'SPORTS_BASEBALL',
  TIMELINE: 'TIMELINE',
  TRENDING_UP: 'TRENDING_UP',
  VIDEO_LIBRARY: 'VIDEO_LIBRARY',
  WORK: 'WORK',

  /** custom icons */
  AVOCADO_BEAN: 'AVOCADO_BEAN',
  BARCODE: 'BARCODE',
  DASHBOARD: 'DASHBOARD',
  GROCERY: 'GROCERY',
  INBODY_SCALE: 'INBODY_SCALE',
  KEY: 'KEY',
  LOOKING_BODY: 'LOOKING_BODY',
  MENU_BOOK: 'MENU_BOOK',
  MONITORING: 'MONITORING',
  PILL: 'PILL',
  SERVICE_TOOLBOX: 'SERVICE_TOOLBOX',
  THUMB_UP: 'THUMB_UP',

  /** solution icons, custom */
  NUTRITION_CHIP: 'NUTRITION_CHIP',
  SCAN_IQ_CHIP: 'SCAN_IQ_CHIP',
  CHALLENGE_CHIP: 'CHALLENGE_CHIP',
} as const;

export type NavigationIconType = ValueOfKey<typeof NAVIGATION_ICON>;
